var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#2A5ADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 11L28.1905 13.1905L17.8095 19.1905L14 21.381V42.1429L17.8095 44.3333L28.2857 50.3333L32.0952 52.5238L35.9048 50.3333L46.1905 44.3333L50 42.1429V21.381L46.1905 19.1905L35.8095 13.1905L32 11ZM21.619 37.7619V25.7619L32 19.7619L42.381 25.7619V37.7619L32 43.7619L21.619 37.7619Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/LINK.4ee0ed178d9fc8998150eb695c9096bb.svg";
export { ForwardRef as ReactComponent };